var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighPowerStations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 49,
    viewBox: "0 0 35 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_5646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3901 34.545C26.5359 34.545 33.9501 27.1308 33.9501 17.985C33.9501 8.83915 26.5359 1.42499 17.3901 1.42499C8.24424 1.42499 0.830078 8.83915 0.830078 17.985C0.830078 27.1308 8.24424 34.545 17.3901 34.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 0.474978C12.8504 0.47763 8.40182 2.32254 5.1221 5.60414C1.84237 8.88574 -7.57478e-07 13.3354 0 17.975C0 27.635 17.49 48.525 17.49 48.525C17.49 48.525 35 27.635 35 17.975C35 15.676 34.547 13.3996 33.6669 11.2757C32.7869 9.15186 31.4969 7.22223 29.8708 5.59707C28.2447 3.97192 26.3144 2.68308 24.19 1.80422C22.0657 0.925346 19.789 0.473665 17.49 0.474978ZM17.49 32.645C14.5857 32.647 11.7461 31.7874 9.33047 30.1751C6.91482 28.5628 5.0317 26.2702 3.91937 23.5874C2.80703 20.9046 2.51548 17.9521 3.08159 15.1035C3.6477 12.2549 5.04604 9.63829 7.09968 7.58465C9.15331 5.53102 11.77 4.13268 14.6185 3.56657C17.4671 3.00045 20.4196 3.29201 23.1024 4.40434C25.7852 5.51668 28.0778 7.3998 29.6901 9.81545C31.3024 12.2311 32.162 15.0707 32.16 17.975C32.16 19.9015 31.7805 21.8091 31.0433 23.5889C30.3061 25.3688 29.2255 26.986 27.8633 28.3482C26.501 29.7105 24.8838 30.7911 23.104 31.5283C21.3241 32.2655 19.4165 32.645 17.49 32.645Z",
    fill: "#429538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6403 9.88495L17.6103 15.7549L23.2803 15.7649L17.5003 26.0649H15.1103L17.2203 19.7449L12.3203 19.7549L15.5003 9.88495H19.6403Z",
    fill: "#429538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_5646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.99,
    height: 48.05,
    fill: "white",
    transform: "translate(0 0.474976)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPowerStations);
export default __webpack_public_path__ + "static/media/High Power Stations.12fe3dcdfb4f6920e409291a3273622d.svg";
export { ForwardRef as ReactComponent };